import React from 'react';
import { useIntl } from 'react-intl';
import Button from 'src/components/Button';
import AgentLogo from 'src/components/ExternalAgentMenu/AgentLogo';
import {
  connectorStatus,
  EXTERNAL_AGENT_ORDER,
  EXTERNAL_AGENTS,
  MCP_SETUP_URL,
} from 'src/components/ExternalAgentMenu/externalAgents';
import type { ConnectedApp } from 'src/types/ConnectedApps';
import messages from './messages';
import styles from './ConnectedApps.module.scss';

/**
 * The external agents the caller has not connected yet, each with a Connect
 * button to the setup guide: this page is where people come to manage
 * connections, so it is also where they can start one. Same matching rule as
 * the AI Agent panel's "Use FileSpin in …" menu.
 */
const AvailableAgents = ({ apps }: { apps: ConnectedApp[] }) => {
  const { formatMessage } = useIntl();
  const missing = EXTERNAL_AGENT_ORDER.map((id) => EXTERNAL_AGENTS[id]).filter(
    (agent) => connectorStatus(agent, apps) === 'not_connected',
  );
  if (missing.length === 0) return null;

  return (
    <div className={styles.available} data-test="connected-apps-available">
      <p className={styles.availableHeading}>{formatMessage(messages.availableHeading)}</p>
      <ul className={styles.list}>
        {missing.map((agent) => (
          <li key={agent.id} className={styles.row} data-test={`connected-apps-available-${agent.id}`}>
            <div className={styles.rowMain}>
              <AgentLogo agent={agent.id} className={styles.agentLogo} />
              <div className={styles.availableText}>
                <strong>{agent.name}</strong>
                <span>{formatMessage(messages.availableDescription, { agent: agent.name })}</span>
              </div>
              <Button
                mode="tertiary"
                size="small"
                onClick={() => window.open(MCP_SETUP_URL, '_blank', 'noopener,noreferrer')}
              >
                {formatMessage(messages.connect)}
              </Button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AvailableAgents;
